import { computed, makeObservable, observable } from 'mobx'

import { IThread } from '~/client/graph'
import { ISaveThreadMutation } from '~/client/graph/operations/generated/ContentObjects.generated'
import Thread from '~/client/src/shared/models/Thread'

import { SAVE_THREAD } from '../../EventStore/eventConstants'
import EventsStore from '../../EventStore/Events.store'

export default class ThreadsStore {
  @observable public isDataReceived = false

  public constructor(private eventsStore: EventsStore) {
    makeObservable(this)
  }

  public create() {
    const thread = new Thread()
    return this.save(thread)
  }

  public receiveOne(id: string, dto: IThread) {
    if (dto) {
      const thread = Object.assign(new Thread(dto.id), dto) as Thread
      this.byId.set(thread.id, thread)
    } else {
      this.byId.delete(id)
    }
  }

  @computed
  public get list(): Thread[] {
    return Array.from(this.byId.values())
  }

  public get byId() {
    return this.eventsStore.appState.threads
  }

  public clearList() {
    this.isDataReceived = false
    this.byId.clear()
  }

  public receiveList(list: IThread[]) {
    this.isDataReceived = false
    this.byId.clear()

    list.forEach(dto => {
      this.receiveOne(dto.id, dto)
    })

    this.isDataReceived = true
  }

  private save(item: Thread): Promise<IThread> {
    return new Promise((resolve, reject) => {
      this.eventsStore.dispatch(
        SAVE_THREAD,
        {
          id: item.id || null,
          projectId: this.eventsStore.appState.activeProject.id,
        },
        (data: ISaveThreadMutation) => resolve(data.saveThread as IThread),
        reject,
      )
    })
  }
}
